import { render, staticRenderFns } from "./MarkdownView.vue?vue&type=template&id=4260296e&scoped=true"
import script from "./MarkdownView.vue?vue&type=script&lang=js"
export * from "./MarkdownView.vue?vue&type=script&lang=js"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=4260296e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260296e",
  null
  
)

export default component.exports